<mtg-media-dialog
  [media]="media$ | async"
  [game]="game$ | async"
></mtg-media-dialog>
